import { EUnitOfMeasure } from '../shared/enum';
import { TInputProductPhysicalDatas } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureMetricLabel } from './enum';

export const drainHeight: TInputProductPhysicalDatas = 'drainHeight';
export const drainUnitWidth: TInputProductPhysicalDatas = 'drainUnitWidth';
export const drainUnitLength: TInputProductPhysicalDatas = 'drainUnitLength';
export const maxUnitaryDrainageCapacity: TInputProductPhysicalDatas = 'maxUnitaryDrainageCapacity';
export const maximumAppliedLoad: TInputProductPhysicalDatas = 'maximumAppliedLoad';
export const hasDrainagePiping: TInputProductPhysicalDatas = 'hasDrainagePiping';

export const productPD = {
    [drainHeight]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainUnitWidth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainUnitLength]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [maxUnitaryDrainageCapacity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeterPerSecondMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFootPerSecondFoot,
        },
    },
    [maximumAppliedLoad]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kiloPascal,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.kiloPsi,
        },
    },
    [hasDrainagePiping]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};
